var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3635_691)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36.6584,
    r: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7539 27.2405C27.7593 27.2405 26.8055 27.6356 26.1023 28.3388C25.399 29.0421 25.0039 29.9959 25.0039 30.9905V31.7405H48.9999V30.9905C48.9999 29.9959 48.6048 29.0421 47.9016 28.3388C47.1983 27.6356 46.2445 27.2405 45.2499 27.2405H28.7539ZM25.0039 41.4905V33.2405H48.9999V41.4905C48.9999 42.485 48.6048 43.4389 47.9016 44.1421C47.1983 44.8454 46.2445 45.2405 45.2499 45.2405H28.7549C27.7603 45.2405 26.8065 44.8454 26.1033 44.1421C25.4 43.4389 25.0049 42.485 25.0049 41.4905M41.2499 38.7405C41.051 38.7405 40.8602 38.8195 40.7196 38.9601C40.5789 39.1008 40.4999 39.2916 40.4999 39.4905C40.4999 39.6894 40.5789 39.8802 40.7196 40.0208C40.8602 40.1615 41.051 40.2405 41.2499 40.2405H44.7499C44.9488 40.2405 45.1396 40.1615 45.2802 40.0208C45.4209 39.8802 45.4999 39.6894 45.4999 39.4905C45.4999 39.2916 45.4209 39.1008 45.2802 38.9601C45.1396 38.8195 44.9488 38.7405 44.7499 38.7405H41.2499Z",
    fill: "#ED8842"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3635_691",
    x: 0.8,
    y: 0.458447,
    width: 72.4,
    height: 72.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.269963 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3635_691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3635_691",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.3265b94a501e4837c8894e9103def619.svg";
export { ForwardRef as ReactComponent };